// extracted by mini-css-extract-plugin
var _1 = "BankAccountsStyles-module__buttonWrapper___Z2nxt";
var _2 = "BankAccountsStyles-module__emailIcon___md9JZ";
var _3 = "BankAccountsStyles-module__link___foSfv";
var _4 = "BankAccountsStyles-module__supportButton___QIbhg";
export { _1 as "buttonWrapper", _2 as "emailIcon", _3 as "link", _4 as "supportButton" }
